import React from 'react';
import PropTypes from 'prop-types';
import { publish, subscribe, unsubscribe } from '@wh/message-bus';
import { IconAsset, Drawer, DrawerItem, AdditionalNavItem } from '@sitebase/web-shell-kit';

const ODDS_FORMAT_CHANGE_TOPIC = 'onOddsFormatChanged';
const ODDS_RENDERER_TYPE = '@sportsbook/odds';
const ODDS_FORMAT_CHANGE_TOPIC_NEW = 'wh.sports.event.oddsformat.changed';

export class OddsMenu extends React.Component {
  state = {
    oddsFormat: '',
    currentOddsIcon: '',
  };

  componentDidMount() {
    this.subscribeId = subscribe(ODDS_FORMAT_CHANGE_TOPIC, this.changeOddsFormat);
  }

  componentWillUnmount() {
    if (this.subscribeId) {
      unsubscribe(this.subscribeId);
    }
  }

  onClick = (id) => () => {
    publish(ODDS_FORMAT_CHANGE_TOPIC, id);
    publish({ topic: ODDS_FORMAT_CHANGE_TOPIC_NEW, data: id });
  };

  findCurrentOddsIcon = (oddsFormat) => {
    const currentOddsItem = this.props.items.find((child) => child.id === oddsFormat);

    return currentOddsItem ? currentOddsItem.icon : '';
  };

  changeOddsFormat = (_, oddsFormat) => {
    if (this.state.oddsFormat !== oddsFormat) {
      this.setState({
        oddsFormat,
        currentOddsIcon: this.props.isNested ? this.findCurrentOddsIcon(oddsFormat) : '',
      });
    }
  };

  renderDropdownContent = () => (
    <Drawer data-test-id={`${ODDS_RENDERER_TYPE}.dropdown_${this.props.id}`}>
      {this.props.items.map((child) => {
        const { id, icon, label } = child;
        const key = `odds_child_${id}`;

        return (
          <DrawerItem
            id={id}
            data-test-id={`${ODDS_RENDERER_TYPE}.item_${id}`}
            icon={icon ? <IconAsset name={icon} /> : undefined}
            active={this.state.oddsFormat === id}
            key={key}
            onClick={this.onClick(id)}
          >
            {label}
          </DrawerItem>
        );
      })}
    </Drawer>
  );

  render() {
    const itemSharedProps = {
      'data-test-id': `${ODDS_RENDERER_TYPE}_${this.props.id}`,
      id: this.props.id,
    };

    if (this.props.isNested) {
      const { currentOddsIcon } = this.state;

      return (
        <DrawerItem {...itemSharedProps} icon={currentOddsIcon ? <IconAsset name={currentOddsIcon} /> : undefined}>
          {this.props.label}
          {this.renderDropdownContent()}
        </DrawerItem>
      );
    }

    return (
      <AdditionalNavItem {...itemSharedProps} label={this.props.label}>
        {this.renderDropdownContent()}
      </AdditionalNavItem>
    );
  }
}

OddsMenu.defaultProps = {
  isNested: false,
};

OddsMenu.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isNested: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
    })
  ),
};

const renderFunction = ({ data }) => <OddsMenu key={data.id} {...data} />;

const buildOddsMenuRenderer = () => ({
  type: ODDS_RENDERER_TYPE,
  render: renderFunction,
  schema: {},
});

const OddsMenuRenderer = buildOddsMenuRenderer();

export const oddsFormatMenuPlugin = {
  beforeRender({ headerRenderers }) {
    headerRenderers.push(OddsMenuRenderer);
  },
};
